const initialState = {
  openFilterDrawer: false,
};

export default function app(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case 'app/TOGGLE_OPEN_FILTER_DRAWER':
      return {
        ...state,
        openFilterDrawer: !state.openFilterDrawer,
      };
    default:
      return state;
  }
}
